import { Box, CircularProgress } from "@mui/material";
import React from "react";
export type LoadBoxType = {
    loading: boolean;
    children: React.ReactNode;
    minHeight?: string;
  };
function LoadBox({children, loading, minHeight} : LoadBoxType ) {
  
  return (
    loading ? <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            minHeight:minHeight ? minHeight : "300px"
          }}
        >
          <CircularProgress></CircularProgress>
        </Box> : <>{children}</>
  );
}
export default LoadBox;